import emailjs from '@emailjs/browser';
import { EMAIL_CONFIG } from '../config/emailConfig';

// Initialize EmailJS with public key
emailjs.init(EMAIL_CONFIG.PUBLIC_KEY);

export const sendContactEmail = async (formData) => {
  try {
    // Get current date and time
    const currentDate = new Date().toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });

    // Template parameters that will be sent to your email template
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      reply_to: formData.email,
      phone: formData.phone || 'Not provided',
      company: formData.company || 'Not provided',
      service: formData.service || 'Not specified',
      message: formData.message,
      to_email: 'info@sutrasync.com', // Your email address
      current_date: currentDate,
    };

    console.log('Sending email with template ID:', EMAIL_CONFIG.TEMPLATE_ID);
    console.log('Template parameters:', templateParams);

    // Send email using EmailJS
    const response = await emailjs.send(
      EMAIL_CONFIG.SERVICE_ID,
      EMAIL_CONFIG.TEMPLATE_ID,
      templateParams,
      EMAIL_CONFIG.PUBLIC_KEY
    );

    console.log('Email sent successfully:', response);
    return { 
      success: true, 
      message: 'Thank you for your message! We will get back to you within 24 hours.' 
    };
  } catch (error) {
    console.error('Email sending failed:', error);
    return { 
      success: false, 
      message: 'Failed to send email. Please try again or contact us directly at info@sutrasync.com' 
    };
  }
};

// Optional: Send auto-reply to the user
export const sendAutoReply = async (userEmail, userName) => {
  try {
    const autoReplyParams = {
      to_email: userEmail,
      to_name: userName,
      from_name: 'Sutrasync Team',
      message: `Namaste ${userName},

Thank you for contacting Sutrasync! We have received your message and will get back to you within 24 hours.

Our team is excited to learn more about your project and how we can help bring your digital vision to life with innovative technology solutions.

Best regards,
The Sutrasync Team
info@sutrasync.com
+91 7483961283
Office: Sector 62, Noida, Uttar Pradesh, India`,
    };

    await emailjs.send(
      EMAIL_CONFIG.SERVICE_ID,
      EMAIL_CONFIG.AUTO_REPLY_TEMPLATE_ID,
      autoReplyParams
    );

    return { success: true };
  } catch (error) {
    console.error('Auto-reply failed:', error);
    return { success: false };
  }
};